















import { Component, Prop, Vue } from "vue-property-decorator";
import MiraDonutComponent from "@/components/mira/MiraDonut.vue";
import MiraPartsLegendComponent from "@/components/mira/MiraPartsLegend.vue";
import { MiraSegment } from "@/utils/MiraDataQualityView";

/**
 * A ring with its legend: beside it from 600 px, on a phone centred above the legend, so the legend
 * keeps the full card width for its labels, shares and counts instead of pushing the page sideways
 * (Mira on phones, 2026-11-03). Zählerstände on Datenqualität and Abschlussarten on Geschäftsentwicklung.
 */
@Component({
  components: {
    "mira-donut": MiraDonutComponent,
    "mira-parts-legend": MiraPartsLegendComponent,
  },
})
export default class MiraDonutWithLegendComponent extends Vue {
  @Prop({ required: true })
  segments!: MiraSegment[];

  @Prop({ required: true })
  centerText!: string;

  @Prop({ default: null })
  caption!: string | null;

  @Prop({ required: true })
  trackColor!: string;

  @Prop({ required: true })
  ariaLabel!: string;
}
